import { render } from "./OfferHelpPage.vue?vue&type=template&id=9cd9e8d2&scoped=true"
import script from "./OfferHelpPage.vue?vue&type=script&lang=js"
export * from "./OfferHelpPage.vue?vue&type=script&lang=js"

import "./OfferHelpPage.vue?vue&type=style&index=0&id=9cd9e8d2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cd9e8d2"]])

export default __exports__